
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';
import { Category } from '../../../models/backend-definitions.module';

@Injectable()
export class CategoryEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    category: Category;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getCategory()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getCategory(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('category/wAll/' + this.routeParams.id).subscribe((res: Category ) => {
                    this.category = res;
                    this.onDataChanged.next(this.category);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(category): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('category/', category).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(category): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('category/', category).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(category): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('category/' + category.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
